
export * from './menu.module';

export * from './components/menu-page/menu-page';
export * from './components/knowhow-page/knowhow-page';
export * from './components/today-page/today-page';
export * from './components/personal-page/personal-page';
export * from './components/corefacts-page/corefacts-page';
export * from './components/profile-page/profile-page';